module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/rs-3b67d7bed888271edff679c68117af49.svg";